<div mat-dialog-title>
  <mat-icon class="title-icon" svgIcon="beam-forecasting-16"></mat-icon>
  <h1 class="title-dialog">New Demo instance</h1>
  <button mat-icon-button mat-dialog-close [disableRipple]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="container-inner-template">
    <div class="popup-body">
      <dx-multi-view [selectedIndex]="selectedIndex" height="100%" [swipeEnabled]="false" [focusStateEnabled]="false">
        <dxi-item>
          <form [formGroup]="formGroup" class="form-container" *dxTemplate>
            <div>
              <div class="title">Complete the demo instance details</div>
              <div class="subtitle">Fill in the information about the demo instance</div>
            </div>
            <dx-text-box
              formControlName="title"
              label="Title*"
              labelMode="floating"
              stylingMode="outlined"
              [validationStatus]="titleFormControl.errors && titleFormControl.touched ? 'invalid' : 'valid'"
              [validationErrors]="[{ type: 'required', message: 'Title is required!' }]"
            ></dx-text-box>
            <dx-select-box
              formControlName="intendedUse"
              label="Intended use*"
              [items]="uses"
              labelMode="floating"
              stylingMode="outlined"
              displayExpr="name"
              valueExpr="id"
              [validationStatus]="intendedUseFormControl.errors && intendedUseFormControl.touched ? 'invalid' : 'valid'"
              [validationErrors]="[{ type: 'required', message: 'Intended use is required!' }]"
            ></dx-select-box>
            <dx-text-box
              *ngIf="showComment"
              formControlName="opportunity"
              label="Comment*"
              labelMode="floating"
              stylingMode="outlined"
              [validationStatus]="opportunityControl.errors && opportunityControl.touched ? 'invalid' : 'valid'"
              [validationErrors]="[{ type: 'required', message: 'Comment is required!' }]"
            ></dx-text-box>
            <dx-select-box
              *ngIf="showOpportunities"
              formControlName="opportunity"
              displayExpr="name"
              [dataSource]="opportunities"
              [showClearButton]="true"
              [searchTimeout]="500"
              [minSearchLength]="3"
              [searchEnabled]="true"
              [noDataText]="noDataText"
              focusStateEnabled="false"
              labelMode="floating"
              stylingMode="outlined"
              label="Choose an opportunity*"
              (onInput)="opportunityTypeSearch($event)"
              [(text)]="opportunitySearchText"
              [validationStatus]="opportunityControl.errors && opportunityControl.touched ? 'invalid' : 'valid'"
              [validationErrors]="[{ type: 'required', message: 'Opportunity is required!' }]"
            >
            </dx-select-box>
            <dx-select-box
              formControlName="region"
              label="Region*"
              [items]="regionDataSource$ | async"
              labelMode="floating"
              stylingMode="outlined"
              displayExpr="name"
              [validationStatus]="regionControl.errors && regionControl.touched ? 'invalid' : 'valid'"
              [validationErrors]="[{ type: 'required', message: 'Region is required!' }]"
            >
            </dx-select-box>
            <dx-text-box formControlName="password" label="Password*" labelMode="floating" stylingMode="outlined" [showClearButton]="true">
              <dxi-button name="new-password-button" location="after" [options]="newPasswordButton"></dxi-button>
              <dx-validator>
                <dxi-validation-rule type="required" message="Password is required!"> </dxi-validation-rule>
                <dxi-validation-rule type="stringLength" [min]="8" [max]="12" message="Password length must be between 8 and 12 characters">
                </dxi-validation-rule>
                <dxi-validation-rule
                  type="pattern"
                  pattern="^(?=.*[0-9])(?=.*[- ?!@#$%^&*\/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*\/\\]{8,12}$"
                  message="Password must contains at least: Upper Case Letters,Lower Case Letters,Numbers, Non-white space special characters."
                >
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </form>
        </dxi-item>
        <dxi-item>
          <div class="view-container" *dxTemplate>
            <div>
              <div class="title">Summary of your demo</div>
              <div class="subtitle">Check the information of your demo instance</div>
            </div>
            <div>
              <div class="label">title</div>
              <div class="value">{{ recapValues.title }}</div>
            </div>
            <div>
              <div class="label">intended use</div>
              <div class="value">{{ recapValues.intendedUse }}</div>
            </div>
            <div *ngIf="recapValues.opportunity">
              <div class="label" *ngIf="showOpportunities">opportunity name</div>
              <div class="label" *ngIf="showComment">comment</div>
              <div class="value">{{ recapValues.opportunity }}</div>
            </div>
            <div>
              <div class="label">region</div>
              <div class="value">{{ recapValues.region }}</div>
            </div>
            <div *ngIf="data.selectedTemplate">
              <div class="label">demo collection</div>
              <brd-template-tile [template]="data.selectedTemplate" [enableAction]="false" [enableHover]="false"></brd-template-tile>
            </div>
            <div *ngIf="data.selectedDemos">
              <div class="label">demos included</div>
              <div class="demos-container">
                <div class="demo" *ngFor="let demo of data.selectedDemos">
                  <mat-icon svgIcon="check-16"></mat-icon><span class="demo-name">{{ demo.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </dxi-item>
      </dx-multi-view>
    </div>
    <div class="popup-action">
      <brd-button *ngIf="selectedIndex === 1" color="default" text="prev" iconName="arrow-left-16" (clickEvent)="prevClick()"></brd-button>
      <div *ngIf="latestVersion$ | async as version" class="board-version">
        <span>Board version</span>
        <strong>{{ version.version }}</strong>
      </div>
      <brd-button class="cancel-btn" color="no-border" text="cancel" (clickEvent)="onNoClick()"></brd-button>
      <brd-button
        color="primary"
        [text]="selectedIndex === 0 ? 'next' : 'create'"
        [iconName]="selectedIndex === 0 ? 'arrow-right-16' : 'check-16'"
        (clickEvent)="selectedIndex === 0 ? nextClick() : createInstance()"
      ></brd-button>
    </div>
  </div>
</div>
<div class="loader-container" *ngIf="loading">
  <mat-spinner diameter="80" strokeWidth="8"></mat-spinner>
</div>
